import {
  initialState,
  Actions,
  State,
  NEW_PLAN,
  NEW_PLAN_SUCCESS,
  NEW_PLAN_ERROR,
  RESET_NEW_PLAN,
} from "../../types/plan/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_PLAN:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_PLAN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_PLAN_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_PLAN:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
